import { ReactNode } from 'react';
import MTab from '@mui/material/Tab';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { TabProps } from '@mui/material/Tab/Tab';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.marginBase,
    '& i': {
      fontSize: 16,
      fontWeight: 'normal',
    },
  },
}));

export interface TabLabelProps {
  label: ReactNode;
  icon?: string;
  labelInner?: ReactNode;
}

type Props = TabLabelProps & TabProps;

export const Tab = ({ icon, label, labelInner, ...rest }: Props) => {
  const classes = useStyles();

  return (
    <MTab
      {...rest}
      label={
        <div className={classes.container}>
          {icon && <i className={icon} />}
          <span>{label}</span>
          {labelInner}
        </div>
      }
    />
  );
};
